/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ToolVariationGroup,
  ToolVariationGroup$inboundSchema,
} from "./toolvariationgroup.js";

export type ToolVariationGroupResult = {
  group: ToolVariationGroup;
};

/** @internal */
export const ToolVariationGroupResult$inboundSchema: z.ZodMiniType<
  ToolVariationGroupResult,
  unknown
> = z.object({
  group: ToolVariationGroup$inboundSchema,
});

export function toolVariationGroupResultFromJSON(
  jsonString: string,
): SafeParseResult<ToolVariationGroupResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ToolVariationGroupResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ToolVariationGroupResult' from JSON`,
  );
}
